const appendCountryId = (params, countryId) => {
  if (countryId != null && countryId !== "") {
    params.append("countryId", String(countryId));
  }
};

export const buildCustomerOrdersUrl = ({ uamId, verticalId, countryId }) => {
  const params = new URLSearchParams({
    uamId: String(uamId),
    verticalId: String(verticalId),
  });
  appendCountryId(params, countryId);
  return `/customerOrders?${params.toString()}`;
};

export const buildPunchOrderUrl = ({ uamId, verticalId, countryId }) => {
  const params = new URLSearchParams({
    uamId: String(uamId),
    verticalId: String(verticalId),
  });
  appendCountryId(params, countryId);
  return `/punchOrder?${params.toString()}`;
};
